/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfVendorFromDiscriminatorValue, createVendorFromDiscriminatorValue, serializeCreateVendorRequest, serializeVendor, type CreateVendorRequest, type ErrorResponse, type InternalErrorResponse, type PagedResultOfVendor, type Vendor } from '../../models/index.js';
// @ts-ignore
import { type WithVendorCodeItemRequestBuilder, WithVendorCodeItemRequestBuilderNavigationMetadata, WithVendorCodeItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { PrefillRequestBuilderRequestsMetadata, type PrefillRequestBuilder } from './prefill/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/vendors
 */
export interface VendorsRequestBuilder extends BaseRequestBuilder<VendorsRequestBuilder> {
    /**
     * The prefill property
     */
    get prefill(): PrefillRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.vendors.item collection
     * @param vendorCode The code of the vendor to update, in any casing. The code itself cannot change.
     * @returns {WithVendorCodeItemRequestBuilder}
     */
     byVendorCode(vendorCode: string) : WithVendorCodeItemRequestBuilder;
    /**
     * Pages the agency's vendors, by name unless told otherwise, with the vendor code as the tiebreak. Deactivated vendors are included unless active is given, so a line card can ask for active=true and an admin screen can show everything. search matches anywhere in the name, ignoring case. An organization with no vendors yet is a success with an empty page. Admins and sales reps of an agency organization may list vendors; a Supplier organization is refused with 403.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfVendor>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<VendorsRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfVendor | undefined>;
    /**
     * Adds a manufacturer line to an agency organization. The vendor code is stored upper-cased and becomes part of the vendor's identifier, so it cannot be changed afterwards; the products of this line carry it as the prefix of their SKU ("HAL-2143"). The whole vendor is written from the body: the name is required, everything else is optional and a list left out is stored empty. A logo or lifestyle image URL that is not in the platform's image storage (the website prefill's logo) is copied into it and the stored URL is kept. A second create with the same code, in any casing, is refused with 409 rather than silently returning the existing vendor. Agency organizations only: a Supplier organization is refused with 403.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Vendor>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 409 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CreateVendorRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Vendor | undefined>;
    /**
     * Pages the agency's vendors, by name unless told otherwise, with the vendor code as the tiebreak. Deactivated vendors are included unless active is given, so a line card can ask for active=true and an admin screen can show everything. search matches anywhere in the name, ignoring case. An organization with no vendors yet is a success with an empty page. Admins and sales reps of an agency organization may list vendors; a Supplier organization is refused with 403.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<VendorsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Adds a manufacturer line to an agency organization. The vendor code is stored upper-cased and becomes part of the vendor's identifier, so it cannot be changed afterwards; the products of this line carry it as the prefix of their SKU ("HAL-2143"). The whole vendor is written from the body: the name is required, everything else is optional and a list left out is stored empty. A logo or lifestyle image URL that is not in the platform's image storage (the website prefill's logo) is copied into it and the stored URL is kept. A second create with the same code, in any casing, is refused with 409 rather than silently returning the existing vendor. Agency organizations only: a Supplier organization is refused with 403.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateVendorRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Pages the agency's vendors, by name unless told otherwise, with the vendor code as the tiebreak. Deactivated vendors are included unless active is given, so a line card can ask for active=true and an admin screen can show everything. search matches anywhere in the name, ignoring case. An organization with no vendors yet is a success with an empty page. Admins and sales reps of an agency organization may list vendors; a Supplier organization is refused with 403.
 */
export interface VendorsRequestBuilderGetQueryParameters {
    /**
     * true returns only active vendors, false only deactivated ones; omitted returns both.
     */
    active?: boolean;
    /**
     * Which page to return, counting from 1.
     */
    pageNumber?: number;
    /**
     * How many vendors per page, 1 to 500.
     */
    pageSize?: number;
    /**
     * Optional text matched anywhere in the vendor name, ignoring case.
     */
    search?: string;
    /**
     * asc or desc.
     */
    sortDirection?: string;
    /**
     * The field to sort on: Name, VendorCode, CreatedAt, UpdatedAt or Active. Ties are broken by vendor code.
     */
    sortOn?: string;
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const VendorsRequestBuilderUriTemplate = "{+baseurl}/api/vendors?pageNumber={pageNumber}&pageSize={pageSize}&sortDirection={sortDirection}&sortOn={sortOn}{&active*,search*,useOrganizationId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const VendorsRequestBuilderNavigationMetadata: Record<Exclude<keyof VendorsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byVendorCode: {
        requestsMetadata: WithVendorCodeItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithVendorCodeItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["vendorCode"],
    },
    prefill: {
        requestsMetadata: PrefillRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const VendorsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: VendorsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfVendorFromDiscriminatorValue,
    },
    post: {
        uriTemplate: VendorsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createVendorFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateVendorRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
